import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

export const useAvatarStyles = makeStyles(
    createStyles({
        backgroundWhite: {
            backgroundColor: "white",
        },
        backgroundBlack: {
            backgroundColor: "black",
        },
    }),
);
